<template>
  <div>
    <div class="vp-mb-25 vp-ml-5 vp-mt-28">
      <h4 class="page-title">RFID Enrollment</h4>
    </div>
    <div class="white-panel">
      <div
        class="d-flex align-items-center users-counter vp-pt-18 vp-pb-24 vp-pl-37"
      >
        <p class="user-selected vp-mr-16">
          {{ table.length - 1 }}
          {{ table.length - 1 == 1 ? "User" : "Users" }} selected
        </p>

        <button
          class="btn btn-secondary"
          :class="{
            'full-opacity': disableState,
            'half-opacity': $v.table.$invalid,
          }"
          :disabled="$v.table.$invalid || disableState"
          @click="intitMassaction"
        >
          <i
            v-if="massActionInit"
            style="margin-inline-end: 3px"
            class="bx bx-loader-alt bx-spin font-size-16 align-middle rounded"
          ></i>
          {{
            massActionInit
              ? $t("signInOut.applying")
              : $t("signInOut.applyForAll")
          }}
        </button>
      </div>
      <p class="applyForAll-note" v-if="!isKioskMandatoryForAtLeastOneUser">
        <b>Note:</b> The "Apply for all" button will be enabled when you select
        a "Kiosk to print badge from" for all users who don't have an email
        address and phone number.
      </p>
    </div>

    <vp-mass-action-table
      :table="table"
      :validations="$v"
      :massActionInit="disableState"
      @onMultiselectInput="onMultiselectInput"
    />

    <b-modal
      id="result-modal"
      size="lg"
      hide-footer
      hide-header
      no-clode-on-esc
      no-close-on-backdrop
      scrollable
    >
      <ResultModal :status="modalStatus" :selectedKiosks="selectedKiosks" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { cloneDeep, uniqBy } from "lodash";
import ResultModal from "./ResultModal.vue";

export default {
  title: "Rfid Enrollment",
  components: { ResultModal },
  validations() {
    if (this.table.length && this.isLoaded) {
      return {
        table: {
          $each: {
            kioskToPrintBadgeFrom: {
              checkIfRequired(model, nestedModel) {
                if (
                  this.getKiosksNotAvailable ||
                  nestedModel?.user?.value == "All"
                )
                  return true;
                return (
                  (nestedModel?.phoneNumber?.value?.length > 0 &&
                    nestedModel?.phoneNumber?.value != "-") ||
                  (nestedModel?.emailAddress?.value?.length > 0 &&
                    nestedModel?.emailAddress?.value != "-") ||
                  (!!nestedModel?.kioskToPrintBadgeFrom?.value &&
                    nestedModel?.kioskToPrintBadgeFrom?.value != "-")
                );
              },
            },
          },
        },
      };
    }
  },
  computed: {
    ...mapGetters("users", ["getRifdMassActionUsers", "getKiosksNotAvailable"]),
    ...mapGetters("authfack", ["currentEntity"]),
  },
  methods: {
    ...mapActions("users", ["clearRfidMassActionData"]),
    ...mapActions("setting", ["sendInstructions"]),
    getActionToBeApplied(hasPassport, phone, email) {
      let msg = "";
      if (hasPassport == 1) msg = "Send the enrollment instructions ";
      else if (hasPassport === 0)
        msg = "Create a Local QuickPass and Send the enrollment instructions";
      else if (hasPassport == null && (phone || email))
        msg =
          "Create a VisiPoint Passport and Send the enrollment instructions ";
      else if (!phone && !email)
        msg = "Print a badge showing the Local QuickPass ";

      return msg;
    },
    onMultiselectInput(item) {
      if (item.massAction) {
        this.table.slice(1).forEach((row) => {
          row.kioskToPrintBadgeFrom.value = item.value;
        });
      } else {
        this.table.slice(1).forEach((row) => {
          if (
            row.kioskToPrintBadgeFrom?.value?.id !=
            this.table[0].kioskToPrintBadgeFrom?.value?.id
          ) {
            this.table[0].kioskToPrintBadgeFrom.value = null;
          }
        });
      }
    },
    async intitMassaction() {
      this.massActionInit = true;
      this.disableState = true;
      //Get all selected kiosks
      const selectedKiosks = this.table
        .slice(1)
        .filter((user) => user.kioskToPrintBadgeFrom?.value)
        ?.map((kiosk) => kiosk.kioskToPrintBadgeFrom.value);

      //Filter kiosks by unique id
      if (selectedKiosks) {
        this.selectedKiosks = uniqBy(selectedKiosks, "id");
      }
      this.table.slice(1).forEach((row) => {
        row.status.value = "Pending";
        row.status.classList = "vp-color-warning-2 vp-font-weight-600";
      });
      for (const userData of this.table) {
        if (!userData.user.massAction) {
          const payload = {
            user_id: userData.user.id,
            entity_id: this.currentEntity.id,
            kiosk_id: userData?.kioskToPrintBadgeFrom?.value?.id || null,
          };
          userData.status.value = "In Progress";
          userData.status.classList = "vp-color-blue-2 vp-font-weight-600";

          await this.sendInstructions(payload);

          userData.status.classList = "vp-color-green-1 vp-font-weight-600";
          userData.status.value = "Completed";
        }
      }

      this.massActionInit = false;

      const kioskNotSelectedForAll = this.table.every(
        (row) => !row.kioskToPrintBadgeFrom?.value
      );
      const isOptionalForAll = this.table
        .slice(1)
        .every(
          (row) =>
            (row.emailAddress.value.length > 0 &&
              row.emailAddress.value != "-") ||
            (row.phoneNumber.value.length > 0 && row.phoneNumber.value != "-")
        );
      const isMandatoryForAll = this.table
        .slice(1)
        .every(
          (row) =>
            (!row.emailAddress.value || row.emailAddress.value == "-") &&
            (!row.phoneNumber.value || row.phoneNumber.value == "-")
        );

      if (kioskNotSelectedForAll && isOptionalForAll) {
        this.modalStatus = "optionalForAllAndNoKioskSelected";
      } else if (isMandatoryForAll) {
        this.modalStatus = "mandatoryForAll";
      } else {
        this.modalStatus = "kioskSelected";
      }

      this.$bvModal.show("result-modal");
    },
  },
  beforeMount() {
    // console.log('this.getRifdMassActionUsers', this.getRifdMassActionUsers);
    this.zIndex = this.getRifdMassActionUsers?.length + 1;
    //remove 'Kiosk To Print Badge From' column if no kiosks exist
    if (this.getKiosksNotAvailable) {
      delete this.tableMap.kioskValue;
      this.table.push({
        user: { ...this.tableMap.userName, value: "All", massAction: true },
        userType: {
          ...this.tableMap.user_type_name,
        },
        emailAddress: {
          ...this.tableMap.email,
        },
        phoneNumber: {
          ...this.tableMap.phone,
        },
        visiointPassport: {
          ...this.tableMap.passport_status,
        },
        actionThatWillBeApplied: { ...this.tableMap.actionThatWillBeApplied },
        status: "",
      });
    } else {
      this.table.push({
        user: { ...this.tableMap.userName, value: "All", massAction: true },
        userType: {
          ...this.tableMap.user_type_name,
        },
        emailAddress: {
          ...this.tableMap.email,
        },
        phoneNumber: {
          ...this.tableMap.phone,
        },
        visiointPassport: {
          ...this.tableMap.passport_status,
        },
        actionThatWillBeApplied: { ...this.tableMap.actionThatWillBeApplied },
        kioskToPrintBadgeFrom: {
          ...this.tableMap.kioskValue,
          options: this.getRifdMassActionUsers[0]?.kiosk,
          massAction: true,
          zIndex: this.zIndex,
        },
        status: "",
      });
    }

    this.getRifdMassActionUsers?.forEach((row) => {
      if (row.email || row.phone || row.kiosk.length > 0) {
        this.zIndex--;
        let newRow = {};
        Object.keys(this.tableMap).forEach((key) => {
          if (key == "actionThatWillBeApplied") {
            let msg = this.getActionToBeApplied(
              row.passport_status,
              row.phone,
              row.email
            );

            newRow[this.tableMap[key].label] = {
              ...this.tableMap[key],
              value: msg,
            };
          } else if (key == "passport_status") {
            const passportValue = row[key];
            newRow[this.tableMap[key].label] = {
              ...this.tableMap[key],
              value:
                passportValue == null
                  ? "No"
                  : passportValue == 1
                  ? "Yes"
                  : "Deactivated",
              classList:
                passportValue == 0
                  ? "vp-color-warning-1 vp-font-weight-700"
                  : "",
            };
          } else if (key == "kioskValue") {
            newRow[this.tableMap[key].label] = {
              ...this.tableMap[key],
              options: row["kiosk"],
              zIndex: this.zIndex,
            };
          } else if (key == "userName") {
            newRow[this.tableMap[key].label] = {
              ...this.tableMap[key],
              value: cloneDeep(row[key] || "-"),
              id: row.user_id,
            };
          } else {
            newRow[this.tableMap[key].label] = {
              ...this.tableMap[key],
              value: cloneDeep(row[key] || "-"),
            };
          }
        });

        Object.assign(newRow, { status: { type: "label", value: "-" } });
        this.table.push(newRow);
      }
    });

    //Check if kiosk is mandatory for at least one user (skip mass action row)
    this.isKioskMandatoryForAtLeastOneUser = this.table
      ?.slice(1)
      .every(
        (user) =>
          (user.phoneNumber?.value?.length > 0 &&
            user.phoneNumber?.value != "-") ||
          (user.emailAddress?.value?.length > 0 &&
            user.emailAddress?.value != "-")
      );

    this.isLoaded = true;
  },
  data() {
    return {
      table: [],
      isKioskMandatoryForAtLeastOneUser: false,
      isLoaded: false,
      tableMap: {
        userName: { type: "label", value: "", label: "user", id: "" },
        user_type_name: { type: "label", value: "", label: "userType" },
        email: { type: "label", value: "", label: "emailAddress" },
        phone: { type: "label", value: "", label: "phoneNumber" },
        passport_status: {
          type: "label",
          value: "",
          label: "visipointPassport",
        },
        actionThatWillBeApplied: {
          type: "label",
          value: "",
          label: "actionThatWillBeApplied",
          classList: "vp-min-width-530",
        },
        kioskValue: {
          type: "multiselect",
          value: null,
          label: "kioskToPrintBadgeFrom",
          width: "247",
          classList: "vp-min-width-248",
          options: [],
        },
      },
      massActionInit: false,
      disableState: false,
      modalStatus: "",
      selectedKiosks: [],
      zIndex: 1,
    };
  },
  beforeCreate() {
    if (!this.$router?.history?.current?.params?.rfidMassAction)
      this.$router.push({ name: "users" });
  },
  destroyed() {
    this.clearRfidMassActionData();
  },
};

window.onbeforeunload = function () {
  let vuex = JSON.parse(localStorage.getItem("vuex"));
  vuex.users.rifdMassActionUsers = [];
  localStorage.setItem("vuex", JSON.stringify(vuex));
};
</script>

<style scoped>
.white-panel {
  background: #ffffff;
  border-start-end-radius: 8px;
  border-start-start-radius: 8px;
}
.applyForAll-note {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  margin-inline-start: 40px;
  padding-bottom: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.25px;
  color: #939393;
}
p.user-selected {
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;

  color: rgba(147, 147, 147, 0.87);
}
button.btn.btn-secondary {
  width: 104px !important;
  height: 28px !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  text-align: center;
  color: #ffffff !important;
  background: #2680eb !important;
  display: flex !important;
  align-items: center !important;
  border: none !important;
  justify-content: center !important;
  border-radius: 13.5px !important;
}

.full-opacity {
  opacity: 1;
}
.half-opacity {
  opacity: 0.4;
}
p {
  margin-bottom: 0;
}
.page-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  margin-inline-start: 9px;
  margin-bottom: 0px !important;
  color: #495057;
}
</style>

<style lang="scss">
.multiselect--active {
  border-radius: 5px;
  border: 2px solid #103f5e;
}

.multiselect__content-wrapper {
  margin-top: 2px !important;
}
</style>
